import { z } from "zod/v4";

import { ScheduleActionTypeList, ScheduleDtoSchema } from "../../dtos/schedule";

export const PutExperienceScheduleRequestBodySchema = z
  .object({
    experienceId: z.uuid(),
    executionTime: z.number(),
    action: z.enum(ScheduleActionTypeList),
    isDelete: z.boolean().default(false),
  })
  .array()
  .default([]);

export type PutExperienceScheduleRequestBodyType = z.infer<
  typeof PutExperienceScheduleRequestBodySchema
>;

export const PutExperienceScheduleResponseBodySchema = z.object({
  schedules: ScheduleDtoSchema.array(),
});

export type PutExperienceScheduleResponseBodyType = z.infer<
  typeof PutExperienceScheduleResponseBodySchema
>;
